import React from 'react';
import Marquee from 'react-fast-marquee';
import { useGetNotificationsQuery } from '@/store/api/notificationApi';

const AlertNotification = () => {
  const { data } = useGetNotificationsQuery(
    { type: 'Alert' },
    { pollingInterval: 30000, refetchOnMountOrArgChange: true }
  );
  const alerts = data?.data?.Alert ?? [];

  if (alerts.length === 0) return null;

  const message = alerts.map((alert) => alert.body).join('  •  ');

  return (
    <div className="bg-[var(--marquee-bg)] z-[1000] lg:fixed h-[28px] w-full flex items-center top-[125px] lg:top-[67.5px]">
      <div className="container-fluid">
        <Marquee speed={50} pauseOnHover pauseOnClick className="h-[28px] scrollbar-hide">
          <span className="flex items-center h-[28px] text-[12px] font-bold leading-[30px] text-headerText">
            {message}
          </span>

          <span className="mx-8 flex items-center h-[28px] text-[12px] font-bold leading-[30px] text-headerText">
            {message}
          </span>
        </Marquee>
      </div>
    </div>
  );
};

export default AlertNotification;
